import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  components: {
    Pagination: Pagination
  },
  props: {
    apiName: {
      required: true,
      type: String,
      default: ""
    },
    tabsIndex: {
      type: Number,
      default: 0
    },
    conditions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ["update:totalNum"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; //来源标示


    var source = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_source; //表格数据

    var tableData = ref([]); // 分页属性    

    var totalNum = ref(0);
    var pageIndex = ref(1); // 表格加载

    var loading = ref(false);
    var tableloading = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_tableloading; // 列表获取

    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    } // 开始投票


    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var page, _yield$globalProperti2, data, total, code;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading.value = true;
                page = {
                  pageIndex: pageIndex.value,
                  pageSize: 10,
                  state: props.tabsIndex
                };
                _context2.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[props.apiName](Object.assign(page, props.conditions));

              case 4:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                total = _yield$globalProperti2.total;
                code = _yield$globalProperti2.code;

                if (code == 0) {
                  totalNum.value = total;
                  tableData.value = data;

                  if (props.tabsIndex == 0) {
                    emit("update:totalNum", total);
                  }

                  loading.value = false;
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getTabledata.apply(this, arguments);
    }

    var start = function start(activityId) {
      function isStart() {
        return _isStart.apply(this, arguments);
      }

      function _isStart() {
        _isStart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _yield$globalProperti, code, msg;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["startVote"](activityId);

                case 2:
                  _yield$globalProperti = _context.sent;
                  code = _yield$globalProperti.code;
                  msg = _yield$globalProperti.msg;

                  if (code == 0) {
                    router.push({
                      name: "investigateDetail",
                      query: {
                        activityId: activityId
                      }
                    });
                    editVisitNum(activityId);
                  } else {
                    ElMessage.warning(msg);
                  }

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return _isStart.apply(this, arguments);
      }

      isStart();
    }; //访问量


    function editVisitNum(_x) {
      return _editVisitNum.apply(this, arguments);
    } // 分页初始化


    function _editVisitNum() {
      _editVisitNum = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["editVisitNum"](id);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _editVisitNum.apply(this, arguments);
    }

    function initData() {
      totalNum.value = 0;
      pageIndex.value = 1;
      loading.value = false;
      tableData.value = [];
      getTabledata();
    } // 分页跳转


    function changPage(val) {
      pageIndex.value = val;
      getTabledata();
    } //查看详情


    var getDetail = function getDetail(activityId, detailId) {
      router.push({
        name: "investigateDetail",
        query: {
          activityId: activityId,
          detailId: detailId
        }
      });
      editVisitNum(activityId);
    };

    return {
      tableData: tableData,
      totalNum: totalNum,
      source: source,
      getDetail: getDetail,
      getTabledata: getTabledata,
      changPage: changPage,
      initData: initData,
      start: start,
      loading: loading,
      tableloading: tableloading
    };
  }
});